<div class="tpl3pl-page-container">
	<div class="tpl3pl-stat-cards-wrap mb-3">
		<div *ngIf="statsLoading && !queueStats" class="tpl3pl-stat-cards-loading">
			<mat-spinner diameter="36"></mat-spinner>
			<span class="text-muted small ml-2">Loading queue summary…</span>
		</div>
		<div class="tpl3pl-stat-cards" *ngIf="queueStats as s">
			<mat-card class="tpl3pl-stat-card">
				<div class="tpl3pl-stat-value">{{ s.total_active }}</div>
				<div class="tpl3pl-stat-label">Active in queue</div>
				<div class="tpl3pl-stat-sublabel">Not archived</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--accent">
				<div class="tpl3pl-stat-value">{{ s.actionable }}</div>
				<div class="tpl3pl-stat-label">Ready to run</div>
				<div class="tpl3pl-stat-sublabel">Pending + failed</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card">
				<div class="tpl3pl-stat-value">{{ s.pending }}</div>
				<div class="tpl3pl-stat-label">Pending</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card">
				<div class="tpl3pl-stat-value">{{ s.exporting }}</div>
				<div class="tpl3pl-stat-label">Exporting</div>
			</mat-card>
			<mat-card
				class="tpl3pl-stat-card tpl3pl-stat-card--warn tpl3pl-stat-card--action"
				tabindex="0"
				role="button"
				(click)="setExportStatusFilterOnly(['failed'])"
				(keydown.enter)="setExportStatusFilterOnly(['failed'])"
				matTooltip="Filter queue to failed rows — use the row refresh button to retry export">
				<div class="tpl3pl-stat-value">{{ s.failed }}</div>
				<div class="tpl3pl-stat-label">Failed</div>
			</mat-card>
			<mat-card
				class="tpl3pl-stat-card tpl3pl-stat-card--action"
				tabindex="0"
				role="button"
				(click)="setExportStatusFilterOnly(['dead_letter'])"
				(keydown.enter)="setExportStatusFilterOnly(['dead_letter'])"
				matTooltip="Filter queue to dead-letter rows — use the row refresh button to retry export">
				<div class="tpl3pl-stat-value">{{ s.dead_letter }}</div>
				<div class="tpl3pl-stat-label">Dead letter</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--ok">
				<div class="tpl3pl-stat-value">{{ s.exported }}</div>
				<div class="tpl3pl-stat-label">Exported</div>
				<div class="tpl3pl-stat-sublabel">In list</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--partial">
				<div class="tpl3pl-stat-value">{{ s.exported_not_shipped ?? 0 }}</div>
				<div class="tpl3pl-stat-label">Exported, not shipped</div>
				<div class="tpl3pl-stat-sublabel">No shipment confirm yet</div>
			</mat-card>
			<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--muted">
				<div class="tpl3pl-stat-value">{{ s.archived_exported }}</div>
				<div class="tpl3pl-stat-label">Archived</div>
				<div class="tpl3pl-stat-sublabel">Exported, hidden</div>
			</mat-card>
		</div>
		<div class="tpl3pl-stat-subrow" *ngIf="queueStats?.open_queue_fillability as fq">
			<div class="tpl3pl-stat-subrow-head">
				<span class="tpl3pl-stat-subrow-title">Open queue fillability</span>
				<span class="tpl3pl-stat-subrow-meta text-muted">Pending / exporting / failed / dead letter · {{ fq.open_queue_orders }} orders (max 5000 scanned)</span>
			</div>
			<div class="tpl3pl-stat-cards">
				<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--ok">
					<div class="tpl3pl-stat-value">{{ fq.fillable }}</div>
					<div class="tpl3pl-stat-label">Fillable</div>
					<div class="tpl3pl-stat-sublabel">Stock covers open lines</div>
				</mat-card>
				<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--partial">
					<div class="tpl3pl-stat-value">{{ fq.partial }}</div>
					<div class="tpl3pl-stat-label">Partial</div>
					<div class="tpl3pl-stat-sublabel">Some lines short</div>
				</mat-card>
				<mat-card class="tpl3pl-stat-card tpl3pl-stat-card--unfill">
					<div class="tpl3pl-stat-value">{{ fq.not_fillable }}</div>
					<div class="tpl3pl-stat-label">Not fillable</div>
					<div class="tpl3pl-stat-sublabel">All stock lines short</div>
				</mat-card>
				<mat-card class="tpl3pl-stat-card">
					<div class="tpl3pl-stat-value">{{ fq.unknown }}</div>
					<div class="tpl3pl-stat-label">Unknown</div>
					<div class="tpl3pl-stat-sublabel">No open lines / ERP</div>
				</mat-card>
			</div>
		</div>
	</div>
	<div class="tpl3pl-toolbar tpl3pl-export-queue-toolbar">
		<div class="tpl3pl-toolbar-filters tpl3pl-toolbar-filters--full">
			<div class="tpl3pl-filter-panel">

				<!-- Primary filters: used on nearly every visit -->
				<div class="tpl3pl-filter-rows">

					<div class="tpl3pl-filter-block">
						<span class="tpl3pl-filter-label">Export status</span>
						<div class="tpl3pl-pills">
							<button *ngFor="let o of exportStatusOptions" type="button"
								class="tpl3pl-pill"
								[class.tpl3pl-pill--on]="isPillActive(exportStatusFilters, o.value)"
								(click)="togglePill(exportStatusFilters, o.value, onServerQueueFiltersChange.bind(this))">
								{{ o.label }}
							</button>
						</div>
					</div>

					<div class="tpl3pl-filter-block">
						<span class="tpl3pl-filter-label">Fillability</span>
						<div class="tpl3pl-pills">
							<button *ngFor="let o of fillabilityOptions" type="button"
								class="tpl3pl-pill"
								[class.tpl3pl-pill--on]="isPillActive(fillabilityFilters, o.value)"
								(click)="togglePill(fillabilityFilters, o.value, onServerQueueFiltersChange.bind(this))">
								{{ o.label }}
							</button>
						</div>
					</div>

				</div>

				<div class="tpl3pl-filter-row--inputs">
					<div class="tpl3pl-filter-group--input">
						<label class="tpl3pl-filter-label">Order # (exact)</label>
						<div class="tpl3pl-input-wrap">
							<input class="tpl3pl-input" type="text" [(ngModel)]="orderFilter" (keyup.enter)="applyQueueFilters()" placeholder="Exact order #">
							<button class="tpl3pl-input-btn" type="button" (click)="applyQueueFilters()" title="Apply">
								<mat-icon>search</mat-icon>
							</button>
						</div>
					</div>
					<div class="tpl3pl-filter-group--input">
						<label class="tpl3pl-filter-label">Customer</label>
						<input class="tpl3pl-input" type="text" [(ngModel)]="customerContainsFilter" (keyup.enter)="applyQueueFilters()" placeholder="Name, debtor #, PO ref…">
					</div>
				</div>

				<!-- Advanced filters: occasional / power-user controls, collapsed by default -->
				<button type="button" class="tpl3pl-filter-toggle"
					[class.tpl3pl-filter-toggle--open]="showAdvancedFilters"
					(click)="showAdvancedFilters = !showAdvancedFilters">
					<mat-icon>{{ showAdvancedFilters ? 'expand_less' : 'expand_more' }}</mat-icon>
					More filters
					<span class="tpl3pl-filter-toggle__badge" *ngIf="advancedFilterCount > 0">{{ advancedFilterCount }}</span>
				</button>

				<div class="tpl3pl-filter-advanced" *ngIf="showAdvancedFilters">

					<div class="tpl3pl-filter-rows">

						<div class="tpl3pl-filter-block">
							<span class="tpl3pl-filter-label">Queue state</span>
							<div class="tpl3pl-pills">
								<button *ngFor="let o of queueStateOptions" type="button"
									class="tpl3pl-pill"
									[class.tpl3pl-pill--on]="isPillActive(queueStateFilters, o.value)"
									(click)="togglePill(queueStateFilters, o.value, onServerQueueFiltersChange.bind(this))">
									{{ o.label }}
								</button>
							</div>
						</div>

						<div class="tpl3pl-filter-block" *ngIf="orderStatusesForSelect.length">
							<span class="tpl3pl-filter-label">ERP status</span>
							<div class="tpl3pl-pills tpl3pl-pills--grid5">
								<button *ngFor="let s of orderStatusesForSelect" type="button"
									class="tpl3pl-pill"
									[class.tpl3pl-pill--on]="isPillActive(erpStatusFilters, +s.order_status_id)"
									[attr.title]="s.name + ' (' + s.order_status_id + ')'"
									(click)="togglePill(erpStatusFilters, +s.order_status_id, onServerQueueFiltersChange.bind(this))">
									{{ s.name }}
								</button>
							</div>
						</div>

						<div class="tpl3pl-filter-block" *ngIf="salespeopleForSelect.length">
							<span class="tpl3pl-filter-label">Salesperson</span>
							<div class="tpl3pl-pills tpl3pl-pills--grid5">
								<button *ngFor="let sp of salespeopleForSelect" type="button"
									class="tpl3pl-pill"
									[class.tpl3pl-pill--on]="isPillActive(salespersonCodes, sp.code)"
									[attr.title]="sp.label"
									(click)="togglePill(salespersonCodes, sp.code, onServerQueueFiltersChange.bind(this))">
									{{ sp.label }}
								</button>
							</div>
						</div>

					</div>

					<div class="tpl3pl-filter-row--inputs">
						<div class="tpl3pl-filter-group--input">
							<label class="tpl3pl-filter-label">Order contains</label>
							<input class="tpl3pl-input" type="text" [(ngModel)]="orderContainsFilter" (keyup.enter)="applyQueueFilters()" placeholder="Substring on order #">
						</div>
						<div class="tpl3pl-filter-group--input">
							<label class="tpl3pl-filter-label">3PL order ID</label>
							<input class="tpl3pl-input" type="text" [(ngModel)]="pgsIdContains" (keyup.enter)="applyQueueFilters()" placeholder="PGS / remote id">
						</div>
						<div class="tpl3pl-filter-group--input">
							<label class="tpl3pl-filter-label">Error</label>
							<input class="tpl3pl-input" type="text" [(ngModel)]="errorContains" (keyup.enter)="applyQueueFilters()" placeholder="Error message text">
						</div>
					</div>

					<div class="tpl3pl-filter-row tpl3pl-filter-row--csv-list">
						<div class="tpl3pl-filter-block tpl3pl-filter-block--csv-list">
							<label class="tpl3pl-filter-label" for="tpl3pl-csv-order-filter">Order # list (CSV filter)</label>
							<p class="tpl3pl-filter-hint small text-muted mb-1">
								Paste one sales order # per line or CSV (first column). Apply reloads the queue to <strong>only</strong> those rows that exist on the queue, combined with your other filters — then use the header checkbox and <strong>Split selected</strong>.
							</p>
							<textarea
								id="tpl3pl-csv-order-filter"
								class="tpl3pl-input tpl3pl-csv-order-filter-textarea"
								rows="4"
								[(ngModel)]="csvOrderListFilterRaw"
								placeholder="1654321&#10;1654322&#10;1654323"></textarea>
							<div class="tpl3pl-csv-order-filter-footer">
								<input
									type="file"
									accept=".csv,.txt,text/csv,text/plain"
									(change)="onCsvOrderListFilterFileSelected($event)"
									class="tpl3pl-csv-order-filter-file" />
								<span class="small text-muted" *ngIf="csvOrderListFilterParsedCount > 0">{{ csvOrderListFilterParsedCount }} unique # — click Apply</span>
							</div>
						</div>
					</div>

					<div class="tpl3pl-filter-advanced__gates">
						<label class="tpl3pl-check">
							<input type="checkbox" [(ngModel)]="overrideCcPaymentGate"> Override payment gate (prepay/CC terms and full-order pre-auth hold)
						</label>
						<label class="tpl3pl-check">
							<input type="checkbox" [(ngModel)]="overrideAvailabilityGate"> Override availability gate (skip fillability check)
						</label>
					</div>

				</div>

				<div class="tpl3pl-filter-panel__footer">
					<div class="tpl3pl-filter-panel__footer-primary">
						<button class="tpl3pl-btn tpl3pl-btn--sm" type="button" (click)="applyNotExportedFillablePreset()" [disabled]="loading" title="Pending / failed / exporting / dead letter + fillable only">
							<mat-icon>bolt</mat-icon> Not exported + fillable
						</button>
						<button class="tpl3pl-btn tpl3pl-btn--sm tpl3pl-btn--primary" type="button" (click)="applyQueueFilters()" [disabled]="loading" title="Reload queue with current filters">
							<mat-icon>filter_list</mat-icon> Apply
						</button>
						<button class="tpl3pl-btn tpl3pl-btn--sm" type="button" (click)="clearFiltersAndReload()" [disabled]="loading" title="Reset all filters">
							<mat-icon>clear_all</mat-icon> Clear all
						</button>
						<label class="tpl3pl-check">
							<input type="checkbox" [(ngModel)]="includeArchived" (ngModelChange)="loadQueue()"> Include archived
						</label>
					</div>
					<div class="tpl3pl-filter-panel__footer-secondary">
						<button
							class="tpl3pl-btn tpl3pl-btn--sm tpl3pl-btn--accent"
							type="button"
							(click)="forceResendByOrderField()"
							[disabled]="loading || processing || rawPushInProgress || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !(orderFilter || '').trim() || !!exportingOrderNo"
							title="Re-send to 3PL after warehouse removed the order; bypasses shipped and duplicate guards">
							<mat-icon>published_with_changes</mat-icon> Force re-send
						</button>
						<div class="tpl3pl-filter-panel__summary" *ngIf="!loading && queueTotal != null">
							<span class="tpl3pl-queue-cap text-muted">
								<span *ngIf="fillabilityFilters.length === 0">Up to 100 rows</span>
								<span *ngIf="fillabilityFilters.length > 0">Up to 500 matches</span>
							</span>
							<span class="text-muted">· {{ queueTotal }} match<span *ngIf="queueTotal !== 1">es</span></span>
							<span class="text-warning" *ngIf="fillabilityScanCapped">· Scan capped</span>
						</div>
					</div>
				</div>
				<p class="tpl3pl-filter-help">Filters combine with <strong>AND</strong> across rows; multiple pills within one row use <strong>OR</strong>. Pills reload automatically; text fields apply on Enter or via Apply.</p>
			</div>
		</div>
		<div class="tpl3pl-toolbar-actions tpl3pl-export-queue-toolbar-actions">
			<button
				mat-stroked-button
				(click)="refreshQueue()"
				[disabled]="loading"
				matTooltip="Reload queue">
				<mat-spinner *ngIf="loading" diameter="20" class="d-inline-block mr-1"></mat-spinner>
				<mat-icon *ngIf="!loading">refresh</mat-icon>
				<span class="ml-1">{{ loading ? 'Loading…' : 'Refresh' }}</span>
			</button>
			<button
				mat-stroked-button
				type="button"
				(click)="openFailedExportMissingSkusDialog()"
				matTooltip="List SKUs parsed from recent failed / dead-letter exports, with stockmaster + locstock (CSV in dialog header)">
				<mat-icon>inventory</mat-icon>
				<span class="ml-1">Missing SKUs</span>
			</button>
			<button
				mat-raised-button
				color="primary"
				(click)="processQueue()"
				[disabled]="processing || loading || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !dataSource?.data?.length"
				matTooltip="Process pending orders in the queue">
				<mat-spinner *ngIf="processing" diameter="20" class="d-inline-block mr-1"></mat-spinner>
				<mat-icon *ngIf="!processing">play_arrow</mat-icon>
				<span class="ml-1">{{ processing ? 'Processing…' : 'Process Queue' }}</span>
			</button>
			<button
				mat-stroked-button
				[matMenuTriggerFor]="queueExportMenu"
				[disabled]="loading || processing || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || exportingReport || !dataSource?.data?.length"
				matTooltip="Export the currently loaded queue rows">
				<mat-spinner *ngIf="exportingReport" diameter="20" class="d-inline-block mr-1"></mat-spinner>
				<mat-icon *ngIf="!exportingReport">file_download</mat-icon>
				<span class="ml-1">{{ exportingReport ? 'Exporting…' : 'Export' }}</span>
			</button>
			<ng-container *ngIf="removableOrdersCount > 0">
				<button
					mat-raised-button
					color="accent"
					type="button"
					class="mr-2"
					(click)="exportSelectedBatch()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || selectedBatchEligibleCount === 0 || !!exportingOrderNo"
					matTooltip="Export every checked pending or failed order, one at a time (same as raw manual push)">
					<mat-icon>playlist_add_check</mat-icon>
					<span class="ml-1">Export selected ({{ selectedBatchEligibleCount }})</span>
				</button>
				<button
					*ngIf="splitPartialBackorderEnabled && selectedBatchSplitCount > 0"
					mat-stroked-button
					color="primary"
					type="button"
					class="mr-2"
					(click)="batchSplitSelected()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
					matTooltip="For each checked row: preview split, then move short lines to a back-order SO when applicable (same rules as Preview split / Execute split). Skips rows with nothing to move.">
					<mat-spinner *ngIf="batchSplitting" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!batchSplitting">call_split</mat-icon>
					<span class="ml-1">{{ batchSplitting ? ('Splitting ' + batchSplitProgress + '…') : ('Split selected (' + selectedBatchSplitCount + ')') }}</span>
				</button>
				<button
					*ngIf="splitPartialBackorderEnabled && selectedBatchSplitCount > 0"
					mat-raised-button
					color="primary"
					type="button"
					class="mr-2"
					(click)="batchSplitSelectedAndExport()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
					matTooltip="For each checked row: split if needed, then export the fillable source SO. Non-fillable sources are skipped; back-order SOs created by the split are not auto-exported.">
					<mat-spinner *ngIf="batchSplitExporting" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!batchSplitExporting">forward_to_inbox</mat-icon>
					<span class="ml-1">{{ batchSplitExporting ? ('Split + export ' + batchSplitExportProgress + '…') : ('Split + export selected (' + selectedBatchSplitCount + ')') }}</span>
				</button>
				<button
					mat-stroked-button
					color="primary"
					type="button"
					class="mr-2"
					(click)="markSelectedAsDispatched()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || selectedMarkDispatchedCount === 0 || !!exportingOrderNo"
					matTooltip="Mark checked failed or dead-letter rows as exported / dispatched when the order already exists at 3PL (e.g. duplicate export). Does not call the API.">
					<mat-spinner *ngIf="batchMarkingDispatched" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!batchMarkingDispatched">published_with_changes</mat-icon>
					<span class="ml-1">{{ batchMarkingDispatched ? 'Updating…' : ('Mark dispatched (' + selectedMarkDispatchedCount + ')') }}</span>
				</button>
				<button
					*ngIf="selectedWarehouseCancelCount > 0"
					mat-stroked-button
					color="warn"
					type="button"
					class="mr-2"
					(click)="batchCancelWarehouseSelected()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
					matTooltip="Cancel each checked order at the 3PL only (ERP unchanged). On success the export queue row is reset to pending so you can split and re-export without Prepare split resubmit.">
					<mat-spinner *ngIf="batchCancellingWarehouse" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!batchCancellingWarehouse">highlight_off</mat-icon>
					<span class="ml-1">{{ batchCancellingWarehouse ? ('Cancelling ' + batchWarehouseCancelProgress + '…') : ('Cancel at warehouse (' + selectedWarehouseCancelCount + ')') }}</span>
				</button>
				<button
					mat-stroked-button
					color="warn"
					type="button"
					class="mr-2"
					(click)="openCsvWarehouseCancelDialog()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
					matTooltip="Paste or upload a CSV / text list of SO numbers; cancel each at the 3PL only (ERP unchanged). Each success resets that order’s queue row to pending for split + re-export.">
					<mat-icon>upload_file</mat-icon>
					<span class="ml-1">Cancel from CSV / list</span>
				</button>
				<button
					*ngIf="selectedBumpOrdernoCount > 0"
					mat-stroked-button
					color="accent"
					type="button"
					class="mr-2"
					(click)="batchBumpOrdernoSelected()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
					matTooltip="Renumber each checked order to the next sales order # (PGS cancel when already at 3PL), one at a time. Then split / export the new SO numbers.">
					<mat-spinner *ngIf="batchBumpingOrdernoForResubmit" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!batchBumpingOrdernoForResubmit">swap_horiz</mat-icon>
					<span class="ml-1">{{ batchBumpingOrdernoForResubmit ? ('Renumbering ' + batchBumpOrdernoProgress + '…') : ('Bump SO # (' + selectedBumpOrdernoCount + ')') }}</span>
				</button>
				<button
					*ngIf="selectedPrepareSplitResubmitCount > 0"
					mat-stroked-button
					type="button"
					class="mr-2"
					(click)="batchPrepareSplitResubmitSelected()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
					matTooltip="Reset queue / idempotency per row (same as row menu Prepare split resubmit) so you can split and re-export">
					<mat-spinner *ngIf="batchPreparingSplitResubmit" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!batchPreparingSplitResubmit">settings_backup_restore</mat-icon>
					<span class="ml-1">{{ batchPreparingSplitResubmit ? ('Preparing ' + batchPrepareSplitResubmitProgress + '…') : ('Prepare split resubmit (' + selectedPrepareSplitResubmitCount + ')') }}</span>
				</button>
				<button
					mat-stroked-button
					color="warn"
					type="button"
					class="mr-2"
					(click)="removeSelectedFromQueue()"
					[disabled]="loading || rawPushInProgress || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || selectedRemovableCount === 0 || !!exportingOrderNo"
					matTooltip="Remove checked pending, failed, or dead-letter rows from the queue (same as row trash)">
					<mat-spinner *ngIf="batchDeleting" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!batchDeleting">delete_outline</mat-icon>
					<span class="ml-1">{{ batchDeleting ? 'Removing…' : ('Remove selected (' + selectedRemovableCount + ')') }}</span>
				</button>
				<button
					mat-stroked-button
					type="button"
					class="mr-2"
					(click)="clearBatchSelection()"
					[disabled]="loading || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !selection.hasValue()"
					matTooltip="Clear all row checkboxes">
					<mat-icon>check_box_outline_blank</mat-icon>
					<span class="ml-1">Clear selection</span>
				</button>
				<mat-form-field appearance="fill" class="tpl3pl-field mr-2 raw-push-limit">
					<mat-label>Batch size</mat-label>
					<mat-select [(ngModel)]="rawPushLimit" (ngModelChange)="onRawPushLimitChange()">
						<mat-option [value]="5">5</mat-option>
						<mat-option [value]="10">10</mat-option>
						<mat-option [value]="20">20</mat-option>
					</mat-select>
				</mat-form-field>
				<button
					mat-stroked-button
					(click)="rawManualPush()"
					[disabled]="loading || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || eligibleOrdersCount === 0"
					matTooltip="Push this many pending/failed orders one at a time and see each API response">
					<mat-spinner *ngIf="rawPushInProgress" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!rawPushInProgress">code</mat-icon>
					<span class="ml-1">{{ rawPushInProgress ? ('Pushing ' + rawPushProgress + '…') : 'Raw manual push' }}</span>
				</button>
			</ng-container>
		<button
			mat-stroked-button
			(click)="archiveAllExported()"
			class="mr-2"
			[disabled]="loading || processing || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit"
			matTooltip="Archive all exported orders (hide from default list)">
			<mat-icon>archive</mat-icon>
			<span class="ml-1">Archive Exported</span>
		</button>
		<button
			mat-stroked-button
			class="mr-2"
			[matMenuTriggerFor]="archivePgsShippedMenu"
			[disabled]="loading || processing || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit"
			matTooltip="Archive only exported rows PGS has marked shipped (queue state Shipped after status refresh)">
			<mat-icon>local_shipping</mat-icon>
			<span class="ml-1">Archive PGS shipped</span>
		</button>
		<mat-menu #archivePgsShippedMenu="matMenu">
			<button mat-menu-item type="button" (click)="archivePgsShippedQueue(false)">
				Shipped only
			</button>
			<button mat-menu-item type="button" (click)="archivePgsShippedQueue(true)">
				Shipped + Invoiced
			</button>
		</mat-menu>
		<mat-form-field appearance="fill" class="tpl3pl-field mr-2 raw-push-limit">
			<mat-label>PGS poll batch</mat-label>
			<mat-select [(ngModel)]="pgsMassBatchSize">
				<mat-option [value]="5">5</mat-option>
				<mat-option [value]="10">10</mat-option>
				<mat-option [value]="25">25</mat-option>
				<mat-option [value]="50">50</mat-option>
			</mat-select>
		</mat-form-field>
		<button
			mat-stroked-button
			(click)="massUpdatePgsStatus()"
			class="mr-2"
			[disabled]="loading || processing || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || massStatusUpdating"
			matTooltip="Poll PGS in small HTTP batches (each order still queried individually); DB updates after each order. Larger batch = more orders per request.">
			<mat-spinner *ngIf="massStatusUpdating" diameter="20" class="d-inline-block mr-1"></mat-spinner>
			<mat-icon *ngIf="!massStatusUpdating">sync</mat-icon>
			<span class="ml-1">{{ massStatusUpdating ? 'Refreshing…' : 'Refresh PGS Status' }}</span>
		</button>
	</div>
</div>

	<mat-menu #queueExportMenu="matMenu">
		<button mat-menu-item (click)="buildQueueHtmlAndExport('pdf')" [disabled]="exportingReport">
			<mat-icon>picture_as_pdf</mat-icon>
			<span>PDF</span>
		</button>
		<button mat-menu-item (click)="buildQueueHtmlAndExport('xlsx')" [disabled]="exportingReport">
			<mat-icon>table_view</mat-icon>
			<span>XLSX</span>
		</button>
	</mat-menu>

	<div *ngIf="massStatusUpdating" class="mt-2 small text-muted">
		{{ massStatusProgress || 'Polling PGS in batches (one order per PGS call per batch request)…' }}
	</div>
	<div *ngIf="massStatusResult" class="mt-2 alert" [ngClass]="massStatusResult.failed > 0 ? 'alert-warning' : 'alert-success'" style="font-size:0.85rem; padding: 8px 12px;">
		<strong>PGS Status Refresh:</strong>
		<span *ngIf="massStatusResult.batch_count" class="text-muted">&nbsp;({{ massStatusResult.batch_count }} HTTP batch(es))&nbsp;</span>
		{{ massStatusResult.checked }} checked &nbsp;·&nbsp;
		<span class="text-success">{{ massStatusResult.updated }} queue state(s) updated</span> &nbsp;·&nbsp;
		<span *ngIf="massStatusResult.erp_status_updated" class="text-info">{{ massStatusResult.erp_status_updated }} ERP status(es) updated</span>
		<span *ngIf="massStatusResult.erp_status_updated">&nbsp;·&nbsp;</span>
		{{ massStatusResult.unchanged }} unchanged &nbsp;·&nbsp;
		<span *ngIf="massStatusResult.failed > 0" class="text-danger">{{ massStatusResult.failed }} failed</span>
		<button mat-icon-button style="float:right; margin-top:-4px;" (click)="massStatusResult = null"><mat-icon>close</mat-icon></button>
		<div *ngIf="massStatusResult.failed > 0 || massStatusResult.updated > 0 || (massStatusResult.erp_status_updated && massStatusResult.erp_status_updated > 0)" class="mt-1" style="max-height:160px; overflow-y:auto;">
			<div *ngFor="let d of massStatusResult.details" class="small">
				<ng-container *ngIf="d.status === 'updated' || d.status === 'error'">
					<span [ngClass]="d.status === 'error' ? 'text-danger' : 'text-success'">
						{{ d.orderno }}
					</span>
					<span class="text-muted ml-1">
						{{ d.status === 'error' ? d.message : (d.old_state + ' → ' + d.new_state + ' (' + d.pgs_status + ')') }}
					</span>
				</ng-container>
				<ng-container *ngIf="d.old_erp_status_id != null && d.new_erp_status_id != null && d.new_erp_status_id !== d.old_erp_status_id">
					<div class="ml-2 text-info">
						{{ d.orderno }} — ERP {{ d.old_erp_status_id }} → {{ d.new_erp_status_id }}
					</div>
				</ng-container>
			</div>
		</div>
	</div>

	<div *ngIf="rawPushInProgress && rawPushProgress" class="mt-2 small text-muted">
		Pushing order ({{ rawPushProgress }})…
	</div>

	<div *ngIf="rawPushResults.length > 0" class="mt-3 raw-push-results-panel">
		<div class="d-flex justify-content-between align-items-center mb-2">
			<strong>Export batch — review failures ({{ rawPushResults.length }} orders)</strong>
			<button mat-stroked-button type="button" (click)="dismissRawPushResults()">Dismiss</button>
		</div>
		<p class="small text-muted mb-2">Shown only when something failed. Use the code icon per row for the API payload. All-success batches only show the toast.</p>
		<table mat-table [dataSource]="rawPushResultsDataSource" class="w-100 compact-table">
			<ng-container matColumnDef="orderno">
				<th mat-header-cell *matHeaderCellDef>Order</th>
				<td mat-cell *matCellDef="let row">{{ row.orderno }}</td>
			</ng-container>
			<ng-container matColumnDef="status">
				<th mat-header-cell *matHeaderCellDef>Status</th>
				<td mat-cell *matCellDef="let row">
					<span [class.badge-success]="row.success" [class.badge-danger]="!row.success" class="badge">{{ row.success ? 'Success' : 'Failed' }}</span>
				</td>
			</ng-container>
			<ng-container matColumnDef="message">
				<th mat-header-cell *matHeaderCellDef>Message</th>
				<td mat-cell *matCellDef="let row" class="message-cell">{{ row.message || '–' }}</td>
			</ng-container>
			<ng-container matColumnDef="view_raw">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let row">
					<button mat-icon-button color="accent" (click)="openRawResponseForResult(row)" matTooltip="View raw response">
						<mat-icon>code</mat-icon>
					</button>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="rawPushResultsColumns"></tr>
			<tr mat-row *matRowDef="let r; columns: rawPushResultsColumns;"></tr>
		</table>
	</div>

	<div *ngIf="lastExportResult && lastExportResult.success" class="mt-3 result-banner">
		<div class="alert alert-success d-flex justify-content-between align-items-center">
			<div><strong>Export:</strong> {{ lastExportResult.message }}</div>
			<button type="button" class="close" aria-label="Close" (click)="dismissLastResult()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>

	<div class="table-responsive position-relative tpl3pl-table-wrapper">
		<div *ngIf="loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Loading orders…</p>
		</div>
		<div *ngIf="processing && !loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Processing queue…</p>
		</div>
		<div *ngIf="(batchDeleting || batchMarkingDispatched) && !loading && !processing && !batchSplitting && !batchSplitExporting && !batchCancellingWarehouse && !batchPreparingSplitResubmit && !batchBumpingOrdernoForResubmit" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">{{ batchMarkingDispatched ? 'Marking selected as dispatched…' : 'Removing selected rows…' }}</p>
		</div>
		<div *ngIf="batchSplitting && !loading && !processing" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Splitting selected orders… {{ batchSplitProgress }}</p>
		</div>
		<div *ngIf="batchSplitExporting && !loading && !processing" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Split + export selected orders… {{ batchSplitExportProgress }}</p>
		</div>
		<div *ngIf="batchCancellingWarehouse && !loading && !processing" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Cancelling at warehouse… {{ batchWarehouseCancelProgress }}</p>
		</div>
		<div *ngIf="batchPreparingSplitResubmit && !loading && !processing" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Prepare split resubmit… {{ batchPrepareSplitResubmitProgress }}</p>
		</div>
		<div *ngIf="batchBumpingOrdernoForResubmit && !loading && !processing" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Renumbering sales orders… {{ batchBumpOrdernoProgress }}</p>
		</div>
		<table mat-table [dataSource]="dataSource" class="w-100 tpl3pl-queue-table" matSort [class.tpl3pl-loading-opacity]="loading || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit">
			<ng-container matColumnDef="select">
				<th mat-header-cell *matHeaderCellDef class="tpl3pl-select-col">
					<mat-checkbox
						(change)="onMasterCheckboxChange($event.checked)"
						[checked]="isAllCheckboxRowsSelected()"
						[indeterminate]="isCheckboxRowsSelectionIndeterminate()"
						[disabled]="loading || processing || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || getCheckboxSelectableLoadedRows().length === 0"
						matTooltip="Select or clear all rows eligible for batch actions (export / remove / warehouse cancel / bump SO # / split / prepare resubmit)">
					</mat-checkbox>
				</th>
				<td mat-cell *matCellDef="let item" class="tpl3pl-select-col">
					<mat-checkbox
						(click)="$event.stopPropagation()"
						(change)="setRowCheckboxSelected(item, $event.checked)"
						[checked]="selection.isSelected(item)"
						[disabled]="!isRowCheckboxSelectable(item) || loading || processing || rawPushInProgress || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
						matTooltip="Includes pending/failed/dead letter, exported rows for warehouse cancel or bump SO #, split/resend, and prepare-split-resubmit targets.">
					</mat-checkbox>
				</td>
			</ng-container>
			<ng-container matColumnDef="orderno">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Order</th>
				<td mat-cell *matCellDef="let item">
					<span class="order-link" (click)="viewOrder(item.orderno)">{{ item.orderno }}</span>
					<span
						*ngIf="item.tpl3pl_split_executed"
						class="badge badge-info tpl3pl-split-badge ml-1"
						[matTooltip]="'Split — back order SO ' + (item.tpl3pl_split_backorder_orderno || '?')">
						Split
					</span>
					<span
						*ngIf="item.tpl3pl_split_parent_orderno && !item.tpl3pl_split_executed"
						class="badge badge-secondary tpl3pl-split-badge ml-1"
						[matTooltip]="'Back order from SO ' + item.tpl3pl_split_parent_orderno">
						BO
					</span>
				</td>
			</ng-container>

		<ng-container matColumnDef="debtorno">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Debtor #</th>
			<td mat-cell *matCellDef="let item">
				<span *ngIf="item.debtorno" class="text-monospace">{{ item.debtorno }}<span *ngIf="item.branchcode">/{{ item.branchcode }}</span></span>
				<span *ngIf="!item.debtorno" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="customer_name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let item">
				<span *ngIf="item.customer_name" class="small">{{ item.customer_name }}</span>
				<span *ngIf="!item.customer_name" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="payterms">
			<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Payment terms code from the order">Terms</th>
			<td mat-cell *matCellDef="let item">
				<span *ngIf="item.payterms" class="text-monospace small">{{ item.payterms }}</span>
				<span *ngIf="!item.payterms" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="export_open_order_total">
			<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Open order total (uninvoiced lines + tax), same basis as pre-export re-auth">Open total</th>
			<td mat-cell *matCellDef="let item" class="text-right">
				<span *ngIf="item.export_open_order_total != null">{{ item.export_open_order_total | currency }}</span>
				<span *ngIf="item.export_open_order_total == null" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="export_preauth_held_total">
			<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Active card holds on this order (when PreAuth is enabled)">Auth held</th>
			<td mat-cell *matCellDef="let item" class="text-right">
				<span *ngIf="item.export_preauth_held_total != null">{{ item.export_preauth_held_total | currency }}</span>
				<span *ngIf="item.export_preauth_held_total == null" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="export_preauth">
			<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Pre-export re-auth or CC/prepay coverage before send">Pre-auth / pay</th>
			<td mat-cell *matCellDef="let item">
				<span *ngIf="item.export_needs_preauth" class="badge badge-warning" [matTooltip]="item.export_preauth_message || 'Re-authorize before export'">Re-auth</span>
				<span *ngIf="!item.export_needs_preauth && item.export_needs_cc_payment" class="badge badge-warning" [matTooltip]="item.export_cc_payment_message || 'Authorization must cover open balance'">CC pay</span>
				<span *ngIf="!item.export_needs_preauth && !item.export_needs_cc_payment" class="text-muted small">OK</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="tpl3pl_remote_order_id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="3PL/PGS order ID from their system">3PL Order ID</th>
				<td mat-cell *matCellDef="let item">
					<span *ngIf="item.tpl3pl_remote_order_id" class="text-monospace">{{ item.tpl3pl_remote_order_id }}</span>
					<span *ngIf="!item.tpl3pl_remote_order_id" class="text-muted">—</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="export_status">
				<th mat-header-cell *matHeaderCellDef mat-sort-header class="status-header-cell">Status</th>
				<td mat-cell *matCellDef="let item" class="status-column-cell">
					<div class="status-cell">
						<span [ngClass]="getStatusBadgeClass(item.export_status)" class="badge">
							{{ getStatusLabel(item.export_status) }}
						</span>
						<span *ngIf="item.archived_at" class="badge badge-secondary ml-1">Archived</span>
						<span *ngIf="item.export_status === 'exported' && item.exported_at" class="status-completed">{{ item.exported_at | date:'short' }}</span>
					</div>
				</td>
			</ng-container>

	<ng-container matColumnDef="state">
		<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Internal queue state / live PGS status">State</th>
		<td mat-cell *matCellDef="let item">
			<span *ngIf="item.state" [ngClass]="getStateBadgeClass(item.state)">{{ item.state }}</span>
			<span *ngIf="!item.state" class="text-muted">—</span>
			<ng-container *ngIf="{ l: getPgsStatusLabel(item), ca: item.pgs_status_checked_at } as pgs">
				<div *ngIf="pgs.l || pgs.ca" class="small text-muted mt-1"
					[matTooltip]="'PGS: ' + (pgs.l || '—') + (pgs.ca ? (' · checked ' + (pgs.ca | date:'short')) : '')">
					<ng-container *ngIf="pgs.l">PGS: {{ pgs.l }}</ng-container>
					<ng-container *ngIf="!pgs.l && pgs.ca">PGS: last checked {{ pgs.ca | date:'short' }}</ng-container>
				</div>
			</ng-container>
		</td>
	</ng-container>

		<ng-container matColumnDef="erp_status">
			<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="ERP order status from salesorders">ERP Status</th>
			<td mat-cell *matCellDef="let item">
				<div class="erp-status-cell">
					<span
						*ngIf="item.erp_order_status_name || item.erp_order_status_id"
						class="erp-status-pill erp-status-pill--with-edit"
						[ngClass]="getErpStatusClass(item.erp_order_status_id)"
						[attr.title]="'Status ID: ' + item.erp_order_status_id">
						<span class="erp-status-pill__text">{{ item.erp_order_status_name || item.erp_order_status_id }}</span>
						<button
							type="button"
							class="erp-status-pill__edit"
							(click)="openForceErpStatusDialog(item); $event.stopPropagation()"
							[disabled]="loading || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
							matTooltip="Force ERP status (direct update; e.g. set Dispatched when 3PL shipped but ERP still Pending)"
							aria-label="Edit ERP status">
							<mat-icon inline>edit</mat-icon>
						</button>
					</span>
					<span *ngIf="!item.erp_order_status_name && !item.erp_order_status_id" class="erp-status-empty">
						<span class="text-muted">—</span>
						<button
							type="button"
							class="erp-status-pill__edit erp-status-pill__edit--bare"
							(click)="openForceErpStatusDialog(item); $event.stopPropagation()"
							[disabled]="loading || processing || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || !!exportingOrderNo"
							matTooltip="Force ERP status (direct update; e.g. set Dispatched when 3PL shipped but ERP still Pending)"
							aria-label="Edit ERP status">
							<mat-icon inline>edit</mat-icon>
						</button>
					</span>
				</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="erp_fillability">
			<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Fillability based on current open order lines and warehouse stock">Fillability</th>
			<td mat-cell *matCellDef="let item">
				<span
					*ngIf="item.erp_fillability && item.erp_fillability !== 'unknown'"
					class="erp-fill-pill"
					[ngClass]="getFillabilityClass(item.erp_fillability)">
					{{ item.erp_fillability_label || item.erp_fillability }}
				</span>
				<span *ngIf="!item.erp_fillability || item.erp_fillability === 'unknown'" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="erp_line_sim">
			<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Simulated line coverage: lines with enough QOH when reached in the global open-order walk, out of stock-consuming open lines (same model as Fillability).">Lines</th>
			<td mat-cell *matCellDef="let item" class="tpl3pl-line-sim-cell">
				<ng-container *ngIf="(item.erp_fill_lines_open || 0) > 0">
					<span class="text-monospace">{{ item.erp_fill_lines_covered }}/{{ item.erp_fill_lines_open }}</span>
				</ng-container>
				<span *ngIf="!(item.erp_fill_lines_open || 0)" class="text-muted">—</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="placedby">
		<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="salesorders.salesperson (rep on the order header)">Salesperson</th>
		<td mat-cell *matCellDef="let item">
			<span *ngIf="item.placedby" class="small">{{ item.placedby }}</span>
			<span *ngIf="!item.placedby" class="text-muted">—</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="enteredby">
		<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="User id who keyed the order (salesorders.enteredby)">Entered by</th>
		<td mat-cell *matCellDef="let item">
			<span *ngIf="item.enteredby" class="small">{{ item.enteredby }}</span>
			<span *ngIf="!item.enteredby" class="text-muted">—</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="created_at">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Recorded</th>
			<td mat-cell *matCellDef="let item">{{ item.created_at | date:'short' }}</td>
		</ng-container>

			<ng-container matColumnDef="export_attempts">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Attempts</th>
				<td mat-cell *matCellDef="let item">{{ item.export_attempts }}</td>
			</ng-container>

			<ng-container matColumnDef="last_export_attempt">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Last attempt</th>
				<td mat-cell *matCellDef="let item">{{ item.last_export_attempt | date:'short' }}</td>
			</ng-container>

			<ng-container matColumnDef="error_message">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Last message</th>
				<td mat-cell *matCellDef="let item" class="error-cell">
					<span
						*ngIf="(item.error_message || item.export_response?.circuit_open) && item.export_status !== 'exported'"
						class="error-summary"
						(click)="openErrorDetails(item)"
						[attr.title]="item.error_message || 'View details'">
						{{ getErrorSummary(item) }}
					</span>
					<span *ngIf="(!item.error_message && !item.export_response?.circuit_open) || item.export_status === 'exported'" class="text-muted">—</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="full_resubmit">
				<th mat-header-cell *matHeaderCellDef matTooltip="Preview split vs full resubmit (bump → split → export)">Resubmit</th>
				<td mat-cell *matCellDef="let item" class="tpl3pl-full-resubmit-cell">
					<div class="tpl3pl-full-resubmit-actions" *ngIf="canRunFullResubmitPathway(item)">
						<button
							mat-icon-button
							type="button"
							color="primary"
							(click)="openSplitBackorderDialog(item)"
							[disabled]="isFullResubmitPathwayLocked(item) || !canOpenSplitBackorderDialog(item)"
							matTooltip="Preview split (lines to move / stay)"
							aria-label="Preview split">
							<mat-icon>visibility</mat-icon>
						</button>
						<button
							mat-icon-button
							type="button"
							color="accent"
							(click)="startFullResubmitPathway(item.orderno)"
							[disabled]="isFullResubmitPathwayLocked(item) || fullPathwayBusyOrderno === item.orderno"
							matTooltip="Full resubmit: PGS cancel if applicable, bump SO #, split shorts, export fillable"
							aria-label="Run full resubmit">
							<mat-spinner *ngIf="fullPathwayBusyOrderno === item.orderno" diameter="20"></mat-spinner>
							<mat-icon *ngIf="fullPathwayBusyOrderno !== item.orderno">bolt</mat-icon>
						</button>
					</div>
					<span *ngIf="!canRunFullResubmitPathway(item)" class="text-muted">—</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef>Actions</th>
				<td mat-cell *matCellDef="let item">
					<div class="actions-cell">
						<mat-spinner *ngIf="exportingOrderNo === item.orderno" diameter="24" class="action-spinner"></mat-spinner>
						<button
							mat-stroked-button
							color="warn"
							type="button"
							class="eq-cancel-warehouse-btn"
							*ngIf="canCancelWarehouseOnly(item) && exportingOrderNo !== item.orderno"
							(click)="cancelAtWarehouseOnly(item); $event.stopPropagation()"
							[disabled]="
								processing ||
								loading ||
								batchDeleting ||
								batchMarkingDispatched ||
								batchSplitting ||
								batchSplitExporting ||
								(!!exportingOrderNo && exportingOrderNo !== item.orderno) ||
								(!!cancellingWarehouseOnlyOrderNo && cancellingWarehouseOnlyOrderNo !== item.orderno) ||
								rowExportActionsLocked
							"
							matTooltip="Cancel this order at the warehouse only. Does not change the ERP (use when the order is already cancelled in the ERP).">
							<mat-spinner *ngIf="cancellingWarehouseOnlyOrderNo === item.orderno" diameter="18" class="mr-1"></mat-spinner>
							<mat-icon *ngIf="cancellingWarehouseOnlyOrderNo !== item.orderno">cancel</mat-icon>
							Cancel this
						</button>
						<button
							mat-icon-button
							type="button"
							*ngIf="exportingOrderNo !== item.orderno && item.export_status === 'pending'"
							(click)="exportOrder(item.orderno)"
							[disabled]="processing || loading || batchDeleting || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || (!!exportingOrderNo && exportingOrderNo !== item.orderno) || isRowExportActionBlocked(item)"
							[matTooltip]="isRowExportActionBlocked(item) ? exportActionBlockedTooltip(item) : 'Export now'"
							aria-label="Export now">
							<mat-icon color="accent">send</mat-icon>
						</button>
						<button
							mat-icon-button
							type="button"
							*ngIf="exportingOrderNo !== item.orderno && canQuickRetryExport(item)"
							(click)="retryExport(item)"
							[disabled]="processing || loading || batchDeleting || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || (!!exportingOrderNo && exportingOrderNo !== item.orderno) || isRowExportActionBlocked(item)"
							[matTooltip]="isRowExportActionBlocked(item) ? exportActionBlockedTooltip(item) : 'Retry export'"
							aria-label="Retry export">
							<mat-icon>refresh</mat-icon>
						</button>
						<button
							mat-icon-button
							type="button"
							color="primary"
							*ngIf="exportingOrderNo !== item.orderno && canAttachCardFromQueue(item)"
							(click)="openAttachCardForQueue(item); $event.stopPropagation()"
							[disabled]="processing || loading || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || rowExportActionsLocked"
							matTooltip="Attach a saved card on file, then pre-authorize open balance (when rep skipped payment)"
							aria-label="Attach card and pre-auth">
							<mat-icon>credit_card</mat-icon>
						</button>
						<button
							mat-icon-button
							type="button"
							*ngIf="exportingOrderNo !== item.orderno"
							[matMenuTriggerFor]="exportQueueRowActionsMenu"
							(click)="exportQueueRowMenuItem = item"
							[disabled]="processing || loading || batchDeleting || batchMarkingDispatched || batchSplitting || batchSplitExporting || batchCancellingWarehouse || batchPreparingSplitResubmit || batchBumpingOrdernoForResubmit || (!!exportingOrderNo && exportingOrderNo !== item.orderno)"
							matTooltip="Order actions"
							aria-label="Open order actions menu">
							<mat-icon>more_vert</mat-icon>
						</button>
					</div>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell text-center text-muted py-4" [attr.colspan]="displayedColumns.length">No orders in the export queue.</td>
			</tr>
		</table>

		<mat-paginator [pageSize]="50" [pageSizeOptions]="[50, 100, 25, 10]"></mat-paginator>
	</div>

	<div *ngIf="selectedErrorDetails" class="mt-3 error-details-card">
		<div class="d-flex justify-content-between align-items-start">
			<div class="flex-grow-1">
				<div class="alert alert-warning mb-1" *ngIf="selectedErrorDetails.circuitOpen">
					<strong>Circuit breaker open.</strong> The request was not sent to the 3PL. No raw response from their API.
				</div>
				<div class="alert alert-danger mb-1">
					<strong>Error for order {{ selectedErrorItem?.orderno }}:</strong>
					<span *ngIf="selectedErrorDetails.errorCode" class="ml-2 text-monospace">({{ selectedErrorDetails.errorCode }})</span>
					<pre *ngIf="!selectedErrorDetails.circuitOpen && selectedErrorDetails.message" class="error-full-message mb-0 mt-1">{{ selectedErrorDetails.message }}</pre>
					<span *ngIf="selectedErrorDetails.circuitOpen || (!selectedErrorDetails.message && !selectedErrorDetails.errorCode)">{{ selectedErrorDetails.circuitOpen ? 'Request blocked by circuit breaker.' : 'No message.' }}</span>
				</div>
				<div class="small text-muted mb-1">
					<span *ngIf="selectedErrorDetails.canRetry">This error can be retried.</span>
					<span *ngIf="!selectedErrorDetails.canRetry">This error appears unrecoverable. Fix the order or configuration before retrying.</span>
				</div>
				<div *ngIf="selectedErrorDetails.skusNotFound?.length" class="alert alert-secondary mb-2 py-2 px-3">
					<strong>SKUs not found at 3PL</strong> (from API error; warehouse may only report one per attempt):
					<ul class="mb-0 mt-1 pl-3">
						<li *ngFor="let s of selectedErrorDetails.skusNotFound">{{ s }}</li>
					</ul>
				</div>
				<div *ngIf="selectedErrorDetails.outboundSkus?.length" class="alert alert-light border mb-2 py-2 px-3">
					<strong>All SKUs on this outbound request</strong> (compare with your ERP / item master):
					<div class="text-monospace small mt-1">{{ selectedErrorDetails.outboundSkus.join(', ') }}</div>
				</div>
				<div class="d-flex align-items-center flex-wrap mt-1 mb-1">
					<button *ngIf="selectedErrorItem && canQuickRetryExport(selectedErrorItem)" mat-stroked-button color="primary" class="mr-2" (click)="retryExport(selectedErrorItem); clearErrorDetails()">
						<mat-icon>refresh</mat-icon> Retry Export
					</button>
					<button *ngIf="selectedErrorItem?.export_response" mat-stroked-button (click)="openResponseDetails(selectedErrorItem); clearErrorDetails()">
						<mat-icon>code</mat-icon> View raw response
					</button>
				</div>
				<div *ngIf="selectedErrorDetails.response" class="mt-1">
					<strong>Last 3PL response:</strong>
					<pre class="mb-0 p-2 bg-light small error-details-pre">{{ selectedErrorDetails.response | json }}</pre>
				</div>
			</div>
			<button type="button" class="close ml-2" aria-label="Close" (click)="clearErrorDetails()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>

	<mat-menu #exportQueueRowActionsMenu="matMenu" class="eq-row-actions-menu">
		<ng-container *ngIf="exportQueueRowMenuItem as m">
			<button
				mat-menu-item
				(click)="runRowMenuExportNow()"
				*ngIf="m.export_status === 'pending' && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked || isRowExportActionBlocked(m)">
				<mat-icon color="accent">send</mat-icon>
				<span>Export now</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuRetryExport()"
				*ngIf="canQuickRetryExport(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked || isRowExportActionBlocked(m)">
				<mat-icon>refresh</mat-icon>
				<span>Retry export</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuAttachCardPreauth()"
				*ngIf="canAttachCardFromQueue(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon color="primary">credit_card</mat-icon>
				<span>Attach saved card &amp; pre-auth</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuSplitBackorder()"
				*ngIf="canOpenSplitBackorderDialog(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon>call_split</mat-icon>
				<span>Preview split / back-order lines</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuCancelAndSplitPreview()"
				*ngIf="canOpenCancelAndSplitBackorderPreviewDialog(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon>fact_check</mat-icon>
				<span>Preview cancel at warehouse &amp; split…</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuSplitUninvoicedOpenLines()"
				*ngIf="canOpenSplitUninvoicedOpenLinesDialog(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon>vertical_split</mat-icon>
				<span>Split uninvoiced lines (new SO)</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuPrepareSplitResubmit()"
				*ngIf="canPrepareSplitResubmit(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon>settings_backup_restore</mat-icon>
				<span>Prepare split resubmit (reset queue)</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuBumpOrderno()"
				*ngIf="canBumpOrdernoFor3plResubmit(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon>swap_horiz</mat-icon>
				<span>Bump SO # for 3PL resubmit</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuForceResend()"
				*ngIf="m.export_status === 'exported' && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon color="accent">published_with_changes</mat-icon>
				<span>Re-send to 3PL</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuCancelWarehouseOnly()"
				*ngIf="canCancelWarehouseOnly(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon color="warn">highlight_off</mat-icon>
				<span>Cancel this (warehouse only · ERP unchanged)</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuCancel3pl()"
				*ngIf="canCancelWarehouseOnly(m) && exportingOrderNo !== m.orderno"
				[disabled]="rowExportActionsLocked">
				<mat-icon color="warn">cancel</mat-icon>
				<span>Cancel at 3PL (preview + sync ERP)</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuViewRaw()"
				[disabled]="previewLoadingOrderNo === m.orderno">
				<mat-icon>code</mat-icon>
				<span>View raw request / response</span>
			</button>
			<button mat-menu-item (click)="runRowMenuViewLogs()" *ngIf="m.export_status === 'failed' || m.export_status === 'dead_letter'">
				<mat-icon>article</mat-icon>
				<span>View logs</span>
			</button>
			<button
				mat-menu-item
				(click)="runRowMenuMarkDispatched()"
				*ngIf="canMarkDispatchedFromFailure(m)"
				[disabled]="rowExportActionsLocked">
				<mat-icon color="primary">published_with_changes</mat-icon>
				<span>Mark dispatched (already at 3PL)</span>
			</button>
			<button mat-menu-item (click)="runRowMenuViewShipments()" *ngIf="m.export_status === 'exported'">
				<mat-icon>local_shipping</mat-icon>
				<span>View shipments</span>
			</button>
			<button mat-menu-item (click)="runRowMenuCheckPgs()" *ngIf="m.export_status === 'exported' || !!m.archived_at || m.state === 'Cancelled'">
				<mat-icon>track_changes</mat-icon>
				<span>Check live PGS status</span>
			</button>
			<button mat-menu-item (click)="runRowMenuArchive()" *ngIf="m.export_status === 'exported' && !m.archived_at">
				<mat-icon>archive</mat-icon>
				<span>Archive (hide from list)</span>
			</button>
			<button mat-menu-item (click)="runRowMenuUnarchive()" *ngIf="m.archived_at">
				<mat-icon>unarchive</mat-icon>
				<span>Unarchive</span>
			</button>
			<mat-divider *ngIf="canRemoveFromQueue(m)"></mat-divider>
			<button
				mat-menu-item
				(click)="runRowMenuDelete()"
				*ngIf="canRemoveFromQueue(m)"
				[disabled]="rowExportActionsLocked"
				class="eq-row-actions-menu__danger">
				<mat-icon color="warn">delete_outline</mat-icon>
				<span>Remove from queue</span>
			</button>
		</ng-container>
	</mat-menu>

</div>
